(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-iphone-duo-story"]) return;
  try {
    
  if (!customElements.get('mp-iphone-duo-story')) {
    customElements.define('mp-iphone-duo-story', class extends HTMLElement {
      connectedCallback() {
        const items = this.querySelectorAll('[data-mp-duo-reveal]');
        this.setAttribute('data-mp-duo-ready', '');
        if (!items.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

        items.forEach((item) => observer.observe(item));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-iphone-story"]) return;
  try {
    
  if (!customElements.get('mp-iphone-story')) {
    class MpIphoneStory extends HTMLElement {
      connectedCallback() {
        this.colorNames = {
          burgundy: this.dataset.colorBurgundy,
          glacier: this.dataset.colorGlacier,
          silver: this.dataset.colorSilver,
          black: this.dataset.colorBlack
        };
        this.onColorChange = this.onColorChange.bind(this);
        document.addEventListener('change', this.onColorChange);
        this.setupReveal();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onColorChange);
        if (this.observer) this.observer.disconnect();
      }

      normalizeColor(value) {
        const normalized = String(value || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
        return {
          borgona: 'burgundy',
          burgundy: 'burgundy',
          glaciar: 'glacier',
          glacier: 'glacier',
          plata: 'silver',
          silver: 'silver',
          negro: 'black',
          black: 'black'
        }[normalized] || normalized;
      }

      onColorChange(event) {
        const input = event.target.closest('.mp-config-option--color input[type="radio"]');
        if (!input || !input.checked) return;
        this.activateColor(this.normalizeColor(input.value));
      }

      activateColor(color) {
        const groups = this.querySelectorAll('[data-mp-story-color]');
        let matched = false;
        groups.forEach((group) => {
          const active = group.dataset.mpStoryColor === color;
          group.hidden = !active;
          if (active) matched = true;
        });
        if (!matched) return;
        this.dataset.activeColor = color;
        const label = this.querySelector('[data-mp-story-finish]');
        if (label) label.textContent = this.colorNames[color] || color;
        const stage = this.querySelector('.mp-iphone-story__media-stage');
        if (stage) stage.scrollLeft = 0;
      }

      setupReveal() {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.classList.add('mp-story-ready');
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        this.querySelectorAll('[data-mp-story-reveal]').forEach((element) => this.observer.observe(element));
      }
    }

    customElements.define('mp-iphone-story', MpIphoneStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-social-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.mpSocialProofInit) return;
    window.mpSocialProofInit = true;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(root) {
      if (root.getAttribute('data-mp-ready') === 'true') return;
      root.setAttribute('data-mp-ready', 'true');

      var track = root.querySelector('[data-mp-social-track]');
      if (!track) return;

      var prev = root.querySelector('[data-mp-social-prev]');
      var next = root.querySelector('[data-mp-social-next]');
      var timer = null;
      var paused = false;
      var visible = false;

      function stepSize() {
        var item = track.firstElementChild;
        if (!item) return track.clientWidth;
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var scrollable = max > 2;
        root.classList.toggle('is-scrollable', scrollable);
        if (prev) prev.disabled = !scrollable || track.scrollLeft <= 2;
        if (next) next.disabled = !scrollable || track.scrollLeft >= max - 2;
      }

      function move(direction) {
        track.scrollBy({ left: direction * stepSize(), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }

      function stopAutoplay() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      if (prev) prev.addEventListener('click', function () { stopAutoplay(); move(-1); });
      if (next) next.addEventListener('click', function () { stopAutoplay(); move(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      if (root.getAttribute('data-autoplay') !== 'true' || reducedMotion.matches) return;

      var interval = Math.max(parseInt(root.getAttribute('data-interval'), 10) || 5000, 4000);

      timer = window.setInterval(function () {
        if (paused || !visible || document.hidden) return;
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 2) return;
        if (track.scrollLeft >= max - 2) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          move(1);
        }
      }, interval);

      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function () { paused = false; });
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (type) {
        track.addEventListener(type, stopAutoplay, { passive: true });
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
        }).observe(root);
      } else {
        visible = true;
      }

      if (reducedMotion.addEventListener) {
        reducedMotion.addEventListener('change', function () {
          if (reducedMotion.matches) stopAutoplay();
        });
      }
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-mp-social-gallery]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
